(() => {
  document.querySelectorAll('dl-gifts-family-y').forEach((root) => {
    if (root.getAttribute('data-has-anchor-cta') === 'true') {
      document.documentElement.style.scrollBehavior = 'smooth';
    }
  });

  function showNextAvailablePopup(popupId) {
    if (!popupId) return;

    const isFinished = localStorage.getItem(`dl-pop-h-finished-${popupId}`);
    const popupElement = document.querySelector(`dl-pop-h[id="${popupId}"]`);

    if (!popupElement) {
      console.warn('[dl-gifts-family-y] popup not found:', popupId);
      return;
    }

    if (isFinished) {
      const nextPopupId = popupElement.btn?.dataset?.dlNextPopId;
      if (nextPopupId) {
        showNextAvailablePopup(nextPopupId);
      }
      return;
    }

    // CTA 手动唤醒：直接 _showPopup(true)，跳过 Braze 等待，避免无反馈卡住
    if (typeof popupElement._showPopup === 'function') {
      popupElement._showPopup(true);
    } else if (typeof popupElement.show === 'function') {
      popupElement.show(true);
    }
  }

  document.addEventListener(
    'click',
    (e) => {
      const a = e.target.closest('a.dl-gifts-family-h__cta');
      if (!a || !a.closest('dl-gifts-family-y')) return;

      const textEl = a.querySelector('.dl-gifts-family-h__cta-text');
      const btnText = (textEl?.textContent || a.textContent || '').trim();

      if (typeof DLPixelH?.capture === 'function') {
        DLPixelH.capture('gifts_family_cta_btn_click', {
          btn_text: btnText,
        });
      }

      const popupId = a.getAttribute('data-dl-popup-id');
      if (popupId) {
        e.preventDefault();
        e.stopPropagation();
        showNextAvailablePopup(popupId);
      }
    },
    true
  );

  const MARQUEE_SPEED_PX_PER_SEC = 42;

  function measureMarquee(viewport) {
    const track = viewport.querySelector('.dl-gifts-family-h__winners-track');
    const group = viewport.querySelector('.dl-gifts-family-h__winners-group');
    if (!track || !group) return;

    const groupWidth = group.getBoundingClientRect().width;
    const viewWidth = viewport.getBoundingClientRect().width;
    const needsMarquee = groupWidth > viewWidth + 0.5;

    track.classList.toggle('is-marquee-active', needsMarquee);

    if (!needsMarquee) {
      track.style.removeProperty('--dl-marquee-distance');
      track.style.removeProperty('--dl-gifts-marquee-duration');
      return;
    }

    const gapStyle = getComputedStyle(track).gap;
    const trackGapPx = parseFloat(gapStyle) || 0;
    const distance = groupWidth + trackGapPx;
    track.style.setProperty('--dl-marquee-distance', `${distance}px`);
    const seconds = Math.max(10, distance / MARQUEE_SPEED_PX_PER_SEC);
    track.style.setProperty('--dl-gifts-marquee-duration', `${seconds}s`);
  }

  function initWinnerMarquees(scope) {
    scope.querySelectorAll('.dl-gifts-family-h__winners-viewport').forEach((viewport) => {
      measureMarquee(viewport);
      const ro = new ResizeObserver(() => measureMarquee(viewport));
      ro.observe(viewport);
      const group = viewport.querySelector('.dl-gifts-family-h__winners-group');
      if (group) ro.observe(group);
    });
  }

  function initAllWinnerMarquees() {
    initWinnerMarquees(document);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initAllWinnerMarquees).catch(initAllWinnerMarquees);
  } else {
    initAllWinnerMarquees();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.querySelector('.dl-gifts-family-h__winners-viewport')) {
      initWinnerMarquees(target);
    }
  });
})();
